export const patientServerUrl = (): string | undefined =>
    process.env.PATIENT_SERVER_BASE_URL;
export const patientInitiatedServerUrl = (): string | undefined =>
    process.env.PATIENT_INITIATED_SERVER_BASE_URL;
